// Mobile search with icon toggle and reduced border radius
(function() {
  
  function createMobileSearchWithPredictive() {
    if (window.innerWidth <= 1023 && !document.querySelector('.mobile-search-bar')) {
      
      // Create the mobile search HTML structure
      const searchContainer = document.createElement('div');
      searchContainer.className = 'mobile-search-bar';
      searchContainer.style.cssText = `
        width: 100%;
        padding: 6px 16px 24px 16px;
        background: #fff;
        border-bottom: 1px solid #e5e5e5;
        position: relative;
        z-index: 999;
      `;
      
      searchContainer.innerHTML = `
        <form action="/search" method="get" role="search" style="position: relative; width: 100%;">
          <div style="position: relative; width: 100%;">
            <input type="text" 
                   name="q" 
                   id="mobile-search-input"
                   placeholder="Search for ..." 
                   autocomplete="off"
                   style="width: 100%; padding: 12px 45px 12px 16px; border: none; background: #f5f5f5; border-radius: 8px; font-size: 16px; color: #000; -webkit-appearance: none;">
            <button type="button" 
                    id="mobile-search-icon"
                    style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; padding: 4px; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; transition: all 0.2s;">
              <svg id="search-icon-svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </button>
          </div>
          <div id="mobile-predictive-results" 
               style="position: absolute; top: 100%; left: 0; right: 0; background: #fff; border: 1px solid #ddd; border-top: none; max-height: 500px; overflow-y: auto; display: none; z-index: 1000; margin-top: 0; box-shadow: 0 4px 12px rgba(0,0,0,0.15);">
          </div>
        </form>
      `;
      
      // Insert after header
      const header = document.querySelector('header.header') || 
                    document.querySelector('header') || 
                    document.querySelector('[data-section-id="header"]');
      
      if (header) {
        header.insertAdjacentElement('afterend', searchContainer);
      } else {
        document.body.insertAdjacentElement('afterbegin', searchContainer);
      }
      
      // Initialize predictive search functionality
      const input = document.getElementById('mobile-search-input');
      const searchIcon = document.getElementById('mobile-search-icon');
      const searchIconSvg = document.getElementById('search-icon-svg');
      const resultsDiv = document.getElementById('mobile-predictive-results');
      const form = searchContainer.querySelector('form');
      let searchTimeout;
      let currentQuery = '';
      let resultsOpen = false;
      
      // Function to toggle icon between search and close
      function toggleIcon(showClose) {
        if (showClose) {
          // Show X icon
          searchIconSvg.innerHTML = `
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          `;
          resultsOpen = true;
        } else {
          // Show search icon
          searchIconSvg.innerHTML = `
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          `;
          resultsOpen = false;
        }
      }
      
      // Handle input
      input.addEventListener('input', function() {
        const query = this.value.trim();
        currentQuery = query;
        
        // Clear previous timeout
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
          resultsDiv.style.display = 'none';
          toggleIcon(false);
          return;
        }
        
        // Debounce search
        searchTimeout = setTimeout(() => {
          fetchPredictiveResults(query);
        }, 300);
      });
      
      // Handle search icon click
      searchIcon.addEventListener('click', function() {
        if (resultsOpen) {
          // Close results
          resultsDiv.style.display = 'none';
          toggleIcon(false);
        } else if (currentQuery) {
          // Submit search
          form.submit();
        }
      });
      
      // Close results when clicking outside
      document.addEventListener('click', function(e) {
        if (!searchContainer.contains(e.target)) {
          resultsDiv.style.display = 'none';
          toggleIcon(false);
        }
      });
      
      // Fetch predictive search results from Shopify API
      function fetchPredictiveResults(query) {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
        
        fetch(url)
          .then(response => response.json())
          .then(data => {
            displayResults(data.resources.results, query);
          })
          .catch(error => {
            console.error('Predictive search error:', error);
          });
      }
      
      // Display results
      function displayResults(results, query) {
        const products = results.products || [];
        const collections = results.collections || [];
        
        if (products.length === 0 && collections.length === 0) {
          resultsDiv.innerHTML = '<div style="padding: 24px; text-align: center; color: #999; font-size: 14px;">No results found</div>';
          resultsDiv.style.display = 'block';
          toggleIcon(true);
          return;
        }
        
        let html = '<div style="padding: 16px 0;">';
        
        // SUGGESTIONS header
        html += '<div style="padding: 0 20px 8px; font-size: 11px; font-weight: 600; color: #999; text-transform: uppercase; letter-spacing: 0.5px;">SUGGESTIONS</div>';
        
        // Show query suggestion
        html += `<div style="padding: 8px 20px; font-size: 14px; color: #666;">${query}</div>`;
        
        // COLLECTIONS section
        if (collections.length > 0) {
          html += '<div style="padding: 16px 20px 8px; font-size: 11px; font-weight: 600; color: #999; text-transform: uppercase; letter-spacing: 0.5px;">COLLECTIONS</div>';
          collections.forEach(collection => {
            html += `
              <a href="${collection.url}" style="display: block; padding: 8px 20px; text-decoration: none; color: #000; font-size: 14px; transition: background 0.2s;" 
                 onmouseover="this.style.background='#f9f9f9'" 
                 onmouseout="this.style.background='transparent'">
                ${collection.title}
              </a>
            `;
          });
        }
        
        // PRODUCTS section
        if (products.length > 0) {
          html += '<div style="padding: 16px 20px 8px; font-size: 11px; font-weight: 600; color: #999; text-transform: uppercase; letter-spacing: 0.5px;">PRODUCTS</div>';
          
          products.forEach(product => {
            const price = product.price ? `£${(product.price / 100 * 100).toFixed(2)}` : '';
            const comparePrice = product.compare_at_price_max && product.compare_at_price_max > product.price 
              ? `£${(product.compare_at_price_max / 100 * 100).toFixed(2)}` 
              : null;
            
            html += `
              <a href="${product.url}" style="display: flex; align-items: flex-start; padding: 12px 20px; text-decoration: none; color: #000; transition: background 0.2s;" 
                 onmouseover="this.style.background='#f9f9f9'" 
                 onmouseout="this.style.background='transparent'">
                <div style="width: 60px; height: 60px; flex-shrink: 0; margin-right: 12px; background: #f5f5f5; overflow: hidden;">
                  ${product.featured_image ? `<img src="${product.featured_image.url}" alt="${product.title}" style="width: 100%; height: 100%; object-fit: cover;">` : ''}
                </div>
                <div style="flex: 1; min-width: 0;">
                  <div style="font-size: 13px; margin-bottom: 2px; color: #999;">${product.vendor || ''}</div>
                  <div style="font-size: 14px; margin-bottom: 6px; line-height: 1.3;">${product.title}</div>
                  <div style="font-size: 13px;">
                    ${comparePrice ? `<span style="text-decoration: line-through; color: #999; margin-right: 6px;">${comparePrice}</span>` : ''}
                    <span style="font-weight: 500;">${price}</span>
                  </div>
                </div>
              </a>
            `;
          });
        }
        
        // SEE ALL RESULTS button
        html += `
          <a href="/search?q=${encodeURIComponent(query)}" 
             style="display: block; margin: 16px 20px 8px; padding: 14px 20px; background: #000; color: #fff; text-decoration: none; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; text-align: center; border-radius: 8px; transition: opacity 0.2s;"
             onmouseover="this.style.opacity='0.85'"
             onmouseout="this.style.opacity='1'">
            SEE ALL RESULTS
          </a>
        `;
        
        html += '</div>';
        resultsDiv.innerHTML = html;
        resultsDiv.style.display = 'block';
        toggleIcon(true);
      }
      
      console.log('Mobile search with icon toggle initialized');
    }
  }
  
  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(createMobileSearchWithPredictive, 300);
    });
  } else {
    setTimeout(createMobileSearchWithPredictive, 300);
  }
  
  // Handle resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 1023) {
        const searchBar = document.querySelector('.mobile-search-bar');
        if (searchBar) searchBar.remove();
      } else {
        createMobileSearchWithPredictive();
      }
    }, 250);
  });
  
})();
